
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.066 12.257l-2.067-.516-.153-.613c.548-.56.926-1.31 1.052-2.084a.93.93 0 00.61-.76l.139-1.109a.931.931 0 00-.527-.955l.047-.938.182-.183c.337-.357.617-.969.04-1.848-.434-.664-1.168-1.001-2.181-1.001-.39 0-1.287 0-2.131.556-2.435.061-2.75 1.266-2.75 2.313 0 .238.052.738.092 1.083a.932.932 0 00-.565.974l.138 1.108c.047.38.322.684.677.781.125.742.484 1.465.998 2.013l-.166.663-2.066.516A3.21 3.21 0 000 15.375c0 .207.168.375.375.375h12.75c.207 0 .375-.17.375-.377 0-1.476-1-2.759-2.434-3.116z","fill":"#fff"}}),_c('path',{attrs:{"d":"M16.324 10.229l-1.26-.316-.062-.249c.328-.357.56-.816.652-1.293a.734.734 0 00.41-.569l.09-.717a.732.732 0 00-.336-.71l.023-.473.085-.085c.205-.218.483-.685.04-1.36-.211-.322-.647-.707-1.522-.707-.26 0-.85 0-1.42.362-.804.025-1.335.244-1.622.666a.402.402 0 00-.044.085 1.99 1.99 0 01-.118.262.35.35 0 00-.033.088 2.268 2.268 0 00-.055.527c0 .096.014.266.03.438.005.045.018.09.04.131.151.303.21.635.17.96l-.094.755a.345.345 0 00.069.233c.073.5.303.993.64 1.374l-.071.283-1.26.315c-.104.027-.2.062-.296.1a.376.376 0 00-.05.671l.842.497c.031.018.063.031.098.04a3.96 3.96 0 011.865 1.099c.07.074.169.115.27.115h4.22a.376.376 0 00.375-.376c0-1.018-.689-1.9-1.676-2.146z","fill":"#fff"}})])
          )
        }
      }
    